module.exports = __webpack_public_path__ + "img/confused.4d39e029.svg";